module.exports = __webpack_public_path__ + "static/media/matilde-hello.c838fb1d.png";